import { render, staticRenderFns } from "./TugBoatInsertData.vue?vue&type=template&id=2822da10&scoped=true&"
import script from "./TugBoatInsertData.vue?vue&type=script&lang=js&"
export * from "./TugBoatInsertData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822da10",
  null
  
)

export default component.exports